import { PageHeader } from '../../components/shell/PageHeader';
import { Button } from '../../components/ui/Button';
import { WIZARD_COPY } from '../brand/brandCopy';
import type { WizardMode } from './steps';
import { BAR_COPY } from './wizardCopy';

/**
 * The wizard's heading (spec:93): "Set up your brand" (a revisit: "Revisit your brand setup"), one
 * sentence, and Exit onboarding on the right, a plain button, on every step.
 */
export function WizardHeader({
  mode,
  disabled,
  onExit,
}: {
  mode: WizardMode;
  disabled: boolean;
  onExit: () => void;
}) {
  return (
    <PageHeader
      title={WIZARD_COPY.heading[mode]}
      description={WIZARD_COPY.sentence[mode]}
      actions={
        <Button type="button" variant="plain" disabled={disabled} onClick={onExit}>
          {BAR_COPY.exit}
        </Button>
      }
    />
  );
}
